import React, { useState, useEffect } from 'react';
import styles from './CursorTooltip.scss';
import { connect } from 'react-redux';

function CursorTooltip({ fabric_overlay: { cursorTooltip, fabricOverlay } }) {
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!fabricOverlay) return;

    const canvas = fabricOverlay.fabricCanvas();

    const onMouseMove = (e) => {
      const rect = canvas.upperCanvasEl.parentElement.getBoundingClientRect();

      setPos({
        x: e.clientX - rect.left + 10,
        y: e.clientY - rect.top + 10,
      });
    };

    canvas.upperCanvasEl.addEventListener('mousemove', onMouseMove);

    return () => {
      canvas.upperCanvasEl.removeEventListener('mousemove', onMouseMove);
    };
  }, [fabricOverlay]);

  if (!cursorTooltip) return null;

  return (
    <div
      className={styles.wrapper}
      style={{
        top: pos.y,
        left: pos.x,
        position: 'absolute',
      }}
    >
      {cursorTooltip}
    </div>
  );
}

const mapStateToProps = (state) => ({
  fabric_overlay: state.fabric_overlay,
  user_id: state.auth.id,
});

export default connect(mapStateToProps, null)(CursorTooltip);
